// extracted by mini-css-extract-plugin
export default {"wobble":"Rxi_7"};